import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Popover, Button, Checkbox } from 'antd';
import EditNode from './edit-node';
const getItemStyle = (isDragging, draggableStyle, index) => (Object.assign({ 
    // some basic styles to make the items look a bit nicer
    userSelect: 'none', lineHeight: '24px', 
    // 拖拽的时候背景变化
    // background: isDragging && '#236fab',
    boxShadow: isDragging && '0px 0px 5px 0px #a5a5a5' }, draggableStyle));
// 展示列可拖动节点
class RightDragField extends React.Component {
    constructor(props) {
        super(props);
        this.nodeType = (items) => {
            let type;
            switch (items) {
                case 'alias':
                    type = 'string';
                    break;
                case 'width':
                    type = 'number';
                    break;
                default:
                    type = 'string';
                    break;
            }
            return type;
        };
        this.changeName = (flag, list, id, key, value) => {
            const newIdList = id.split('_');
            if (flag) {
                const data = {
                    id: newIdList[newIdList.length - 1],
                    key,
                    value,
                    stateKey: list,
                };
                this.props.onClildrenChange && this.props.onClildrenChange(data);
            }
            this.setState({
                visible: false,
            });
        };
        this.onPopoverChange = (key) => {
            this.setState({
                visible: key,
            });
        };
        this.checkChange = (item, e) => {
            const { checkedChange } = this.props;
            if (e.target.checked) {
                this.setState({
                    checked: item.id,
                });
            }
            else {
                this.setState({
                    checked: null,
                });
            }
            checkedChange && checkedChange(Object.assign(Object.assign({}, item), { index: this.props.index }), e.target.checked);
        };
        this.state = {
            visible: false,
            checked: null,
        };
    }
    componentDidUpdate(prevProps) {
        const { checkedList } = this.props;
        if (checkedList !== prevProps.checkedList) {
            let obj = checkedList.find((current) => current.id === this.props.item.id);
            if (obj) {
                this.setState({
                    checked: obj.id,
                });
            }
            else {
                this.setState({
                    checked: null,
                });
            }
        }
    }
    render() {
        const { columns, item, index, showRightNum, dragHolderMessag } = this.props;
        const { visible, checked } = this.state;
        return (<Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                {(provided, snapshot) => (<div ref={provided.innerRef} className={index % 2 === 0 ? 'drag-columns-one' : 'drag-columns-two'} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style, index)}>
                        <div className="columns-sort-drag-header">
                            <div className="columns-sort-drag-header-num-empty">
                                <Checkbox onChange={this.checkChange.bind(this, item)} checked={checked === item.id}></Checkbox>
                                {/* <Icon antdIcon type="UnorderedListOutlined" /> */}
                            </div>
                            {showRightNum && <div className="columns-sort-drag-header-num">{index + 1}</div>}

                            {columns &&
                    columns
                        .filter((itemss) => !itemss.selectOptionsHide)
                        .map((items) => {
                        const style = items.selectOptionsWidth
                            ? {
                                width: items.selectOptionsWidth,
                            }
                            : items.width && {
                                width: items.width,
                            };
                        return (<div className="columns-sort-drag-header-field-info" key={items.key} style={style} title={!items.render && item[items.key]}>
                                                {items.render ? (items.render(item.key, item)) : items.editFlag ? (<Popover visible={visible === `selectOptionsList_${items.key}_${item.id}`} content={<EditNode value={item[items.key]} id={`selectOptionsList_${items.key}_${item.id}`} name={items.key} nodeType={this.nodeType(items.key)} type="selectOptionsList" changeName={this.changeName} dragHolderMessag={dragHolderMessag}/>} title={`编辑${items.title}`} trigger="click">
                                                        <Button type="link" onClick={this.onPopoverChange.bind(this, `selectOptionsList_${items.key}_${item.id}`)}>
                                                            {item[items.key]}
                                                        </Button>
                                                    </Popover>) : (item[items.key])}
                                            </div>);
                    })}
                        </div>
                    </div>)}
            </Draggable>);
    }
}
// 展示列可拖动节点
class RightDropField extends React.Component {
    constructor(props) {
        super(props);
        this.checkedChange = (field, checked) => {
            let data = [];
            const { checkedList } = this.state;
            if (checked) {
                checkedList.push(field);
                data = checkedList;
            }
            else {
                const list = checkedList.filter((item) => field.id !== item.id);
                this.setState({
                    checkedList: list,
                });
                data = list;
            }
            this.props.checkedChange && this.props.checkedChange(data);
        };
        this.state = {
            checkedList: [],
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.students === nextProps.students &&
            this.props.rightPagetions === nextProps.rightPagetions &&
            this.props.rightAllChecked === nextProps.rightAllChecked &&
            this.state.checkedList === nextState.checkedList) {
            return false;
        }
        return true;
    }
    componentDidUpdate(prevProps) {
        // if (this.props.students !== prevProps.students) {
        //     console.log(this.props.students);
        //     console.log(prevProps.students);
        //     console.log(222222222);
        //     this.setState({
        //         checkedList: [],
        //     });
        // }
        if (this.props.rightAllChecked !== prevProps.rightAllChecked) {
            this.setState({
                checkedList: this.props.rightAllChecked,
            }, () => {
                this.props.checkedChange && this.props.checkedChange(this.props.rightAllChecked);
            });
        }
    }
    render() {
        const { checkedList } = this.state;
        const { columns, students, onClildrenChange, rightPagetions, showRightNum, propsRightPagetions, dragHolderMessag, } = this.props;
        const maxNum = rightPagetions.pageNum * rightPagetions.pageSize;
        const minNum = rightPagetions.pageNum ? (rightPagetions.pageNum - 1) * rightPagetions.pageSize : 0;
        return students
            .filter((_item, index) => (!propsRightPagetions ? true : minNum <= index && index < maxNum))
            .map((item, index) => (<RightDragField checkedList={checkedList} checkedChange={this.checkedChange} item={item} index={index} columns={columns} key={item.id} showRightNum={showRightNum} onClildrenChange={onClildrenChange} dragHolderMessag={dragHolderMessag}/>));
    }
}
export default RightDropField;
